/**
 * TibiMedia Customer API
 *
 * Contact: administratie@tibimedia.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SingleUploadResponse { 
    /**
     * Indicates a single presigned PUT upload
     */
    uploadType: SingleUploadResponseUploadTypeEnum;
    /**
     * Presigned PUT URL for direct S3 upload
     */
    uploadUrl: string;
    /**
     * Full S3 object key
     */
    objectKey: string;
    /**
     * URL expiration time in seconds
     */
    expiresIn: number;
}
export enum SingleUploadResponseUploadTypeEnum {
    Single = 'single'
};



